import React, { FunctionComponent } from 'react';
import { Button, Container } from './ButtonPillRow.style';

export interface ButtonPill {
  text: string;
  href?: string;
  onClick?: () => void;
  active?: boolean;
  testID?: string;
}

interface Props {
  buttons: ButtonPill[];
}

const ButtonPillRow: FunctionComponent<Props> = (props) => {
  return (
    <Container>
      {props.buttons.map(({ text, href, onClick, active, testID }) => (
        <Button
          key={text}
          $active={active}
          as={href ? undefined : 'button'}
          // @ts-ignore
          href={href}
          onClick={onClick}
          data-testid={testID}
          aria-checked={active}
        >
          {text}
        </Button>
      ))}
    </Container>
  );
};

export default ButtonPillRow;
